/* Street coordinates use the same 2752×1536 cover canvas as the original cast. */
(() => {
  // Release NPC placement is owned by the shared scene coordinate mapper.

  // The current title video owns the soundtrack. Web Audio supplies a real
  // gain stage on iOS, where setting HTMLMediaElement.volume is insufficient.
  const nodes = new WeakMap();
  let context;
  let unlocked = false;
  const preference = () => {
    // Share the speaker's state, including its fallback when storage is blocked.
    // Music stays off until a visitor explicitly chooses to unmute it.
    if (typeof window.haIsMusicMuted === 'function') return window.haIsMusicMuted();
    try { return localStorage.getItem('ha_music_muted') !== '0'; }
    catch (_) { return true; }
  };
  const videos = () => [...document.querySelectorAll('video[id^="fixed-background-video"]')];
  // Shopify Files can be on a different origin. Set CORS before fetching;
  // re-load any eagerly armed source once, while the title is still muted.
  videos().forEach(video => {
    if (video.crossOrigin === 'anonymous') return;
    video.muted = true;
    video.crossOrigin = 'anonymous';
    if (video.currentSrc) video.load();
  });
  const apply = () => {
    const mobile = matchMedia('(max-width: 768px)').matches;
    const desktop = document.getElementById('fixed-background-video');
    const portrait = document.getElementById('fixed-background-video-mobile-portrait');
    const active = (mobile ? portrait : desktop) || portrait || desktop;
    // Retired MP3 players must not double the video's soundtrack or bypass gain.
    document.querySelectorAll('#bgMusic, audio.mp3-player').forEach(a => { a.muted = true; });
    videos().forEach(video => { if (video !== active) video.muted = true; });
    if (!active) return;
    active.muted = true;
    if (!unlocked || preference()) return;
    try {
      const Context = window.AudioContext || window.webkitAudioContext;
      if (!Context) return; // Never fall back to full-volume mobile playback.
      context ||= new Context();
      let node = nodes.get(active);
      if (!node) {
        const source = context.createMediaElementSource(active);
        const gain = context.createGain();
        gain.gain.value = 0;
        source.connect(gain);
        let analyser;
        // Opt-in staging diagnostic; no timers or analysis in normal visits.
        if (new URLSearchParams(location.search).has('audio_check')) {
          analyser = context.createAnalyser();
          gain.connect(analyser);
          analyser.connect(context.destination);
        } else gain.connect(context.destination);
        node = { source, gain, analyser };
        nodes.set(active, node);
      }
      // Landscape phones can exceed 768px; touch-primary devices keep the cap.
      const level = mobile || matchMedia('(pointer: coarse)').matches ? .1 : .15;
      node.gain.gain.setValueAtTime(level, context.currentTime);
      active.volume = 1;
      active.dataset.musicGain = String(level);
      active.muted = false;
      context.resume().then(() => {
        active.dataset.musicState = context.state;
        if (node.analyser) {
          setTimeout(() => {
            const samples = new Float32Array(node.analyser.fftSize);
            node.analyser.getFloatTimeDomainData(samples);
            active.dataset.musicSignal = String(Math.max(...samples.map(Math.abs)));
          }, 1000);
        }
      }).catch(() => { active.muted = true; });
    } catch (_) {
      active.muted = true;
      active.dataset.musicGain = 'unavailable';
    }
  };
  // Install after the legacy title's DOM-ready initialization. Its existing
  // mute button, start action and navigation hooks keep calling this one API.
  const install = () => {
    window.haApplyVideoAudio = apply;
    apply();
    document.addEventListener('hound:experience-start', () => { unlocked = true; apply(); });
    document.addEventListener('click', event => {
      if (!event.target.closest('.ha-music-toggle')) return;
      unlocked = true;
      apply();
    }, true);
    document.addEventListener('play', event => {
      if (event.target.matches?.('#bgMusic, audio.mp3-player')) event.target.muted = true;
    }, true);
    addEventListener('resize', apply, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && unlocked) apply();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
  else install();
})();
